export default __webpack_public_path__ + "7ee8240e5eb2c22d7ec22b25da601c04.png";